import React from 'react';

const BetaNews = () => {
  return (
    <p>
        TBDv BetaNews
    </p>
  );
};

export default BetaNews;

